import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import FigoLottie from '../../common/FigoLottie';

import careCreditCard from '../../../assets/care-credit/care-credit-card.png';
import figoLogo from '../../../assets/care-credit/figo-logo.png';
import careCreditLogo from '../../../assets/care-credit/care-credit-logo.png';

import { useCareCreditValidation } from '../../../hooks';

import './CareCredit.css';

const CareCredit = ({ classContainer = '' }) => {
  const { t } = useTranslation('insurance');
  const { careCredit } = useCareCreditValidation();

  if (careCredit.loading) {
    return (
      <section className="Care-credit-card-loading-container">
        <FigoLottie />
      </section>
    );
  }

  if (!careCredit.hasCareCreditUrl) {
    return null;
  }

  return (
    <section className={`Care-credit-card ${classContainer}`}>
      <div className="Care-credit-card-left-content">
        <img
          alt=""
          className="Care-credit-care-credit-card"
          src={careCreditCard}
        />

        <div className="Care-credit-card-col">
          <div className="Care-credit-card-row">
            <img alt="" className="Care-credit-figo-logo" src={figoLogo} />

            <div className="Care-credit-separator" />

            <img
              alt=""
              className="Care-credit-care-credit-logo"
              src={careCreditLogo}
            />
          </div>

          <div
            className="Care-credit-card-row Care-credit-card-margin-top-tablet"
          >
            <img
              alt=""
              className="Care-credit-care-credit-card-tablet"
              src={careCreditCard}
            />

            <span className="Care-credit-description">
              <Trans
                components={{
                  italic: <span className="Care-credit-description-italic" />,
                }}
                i18nKey="careCredit.description"
                ns="insurance"
              />
            </span>
          </div>
        </div>
      </div>

      <div className="Care-credit-card-right-content">
        <a
          href={careCredit.careCreditUrl}
          rel="noopener noreferrer"
          target="_blank"
        >
          {t('careCredit.learnMore')}
        </a>

        <span className="Care-credit-card-disclaimer">
          <Trans
            components={{
              bold: <span className="Care-credit-card-disclaimer-bold" />,
            }}
            i18nKey="careCredit.disclaimer"
            ns="insurance"
          />
        </span>
      </div>
    </section>
  );
};

const CareCreditMemo = React.memo(CareCredit);

export { CareCreditMemo as CareCredit };
